import { Component, OnInit } from '@angular/core';
import {PlayersService} from "../../../services/players.service";
import {statsHasErrors} from "@angular-devkit/build-angular/src/webpack/utils/stats";
import {SuperUserMethodsService} from "../../../services/super-user-methods.service";
import {isEqual} from "lodash";

@Component({
  selector: 'app-judge-search',
  templateUrl: './judge-search.component.html',
  styleUrls: ['./judge-search.component.scss']
})
export class JudgeSearchComponent implements OnInit {


  private _hoveredDeleteIndex: number;
  private typedPlayer;
  private searchResults;
  private judgesList = [];
  private _searchPlaceHolder: string = 'Фамилия судьи';
  private _judgeSearchInputToCheck;
  constructor(
    private playersService: PlayersService,
    private suServe: SuperUserMethodsService,
  ) { }

  ngOnInit(): void {
    this._judgeSearchInputToCheck = document.getElementById('judgeSearchInput');
  }

  getTypedPlayer() {
    return this.typedPlayer;
  }

  setTypedPlayer(playerFullName) {
    this.typedPlayer = playerFullName;
  }

  getSearchResults() {
    return this.searchResults;
  }

  setSearchResults(listOfValues) {
    this.searchResults = listOfValues;
  }

  getJudgesList() {
    return this.judgesList;
  }

  addJudge(judge, index) {
    this.judgesList.push(judge);
    this.getSearchResults().splice(index, 1);
    this.suServe.appendNewJudgeId(judge.id);
  }

  handleInputChange($event) {
    const name = $event;
    this.setTypedPlayer(name);
    if (name) {
      this.playersService.search(name).subscribe(players => {
        if (name === this._judgeSearchInputToCheck.value) {
          this.setSearchResults(players);
          this.setSearchResults(
            this.getSearchResults().filter(
              (player) => player.last_name.toLowerCase().startsWith(name.toLowerCase()) && this.playerIsNotAJudge(player))
          );
        }
      });
    } else {
      this.setSearchResults(null);
    }
  }

  noResults() {
    return this.getTypedPlayer() && !this.getSearchResults()?.length;
  }

  judgesWereSelected() {
    return this.judgesList?.length;
  }

  get searchPlaceHolder(): string {
    return this._searchPlaceHolder;
  }

  onJudgeDelete(index: number) {
      this.getJudgesList().splice(index, 1);
  }

  canRegisterAnotherJudge() {
    // return this.getJudgesList().length < 6;
    return true;
  }

  playerIsNotAJudge(playerObject) {
    if (!this.getSearchResults()?.length) {
      return true;
    }

    let result = false;
    this.getJudgesList().forEach((judgeObject) => {
      result ||= isEqual(judgeObject, playerObject);
    });

    return !result;
  }

  judgeStyleOnHover(index) {
    return index === this.hoveredDeleteIndex
      ? 'judgeHoverClass'
      : '';
  }

  setIndexOnHover(index) {
    console.debug('this is an index!', index);
    this.hoveredDeleteIndex = index;
  }

  clearIndexOnHover() {
    this.hoveredDeleteIndex = -1;
  }


  get hoveredDeleteIndex(): number {
    return  this._hoveredDeleteIndex;
  }

  set hoveredDeleteIndex(value) {
    this._hoveredDeleteIndex = value;
  }
}
